import {
  WORKER,
  WORKER_PAYROLL,
  WRK_CATEGORY,
  WRK_DESIGNATION,
  WRK_GRADE,
  WRK_CODE_CONFIG,
  WRK_WORK_TYPE,
  WRK_LABOR_TYPE,
  WRK_MAJOR_PRODUCT,
  WRK_MACHINE,
  WRK_LEAVE_TYPE,
  WRK_LEAVE_FOR_WORKER,
  WRK_ATTENDANCE_FOR_WORKER,
  WRK_WORKER_ATTENDANCE,
  WRK_WORKER_LEAVE,
  LW_MY_REQUESTS,
  LW_PENDING_APPROVALS,
  WRK_APPROVAL_WORKFLOW,
  WRK_DAILY_OUTPUT,
  WRK_PIECE_RATE,
  WRK_WAGE_SETTINGS,
  WRK_WAGE_SHEET,
  WRK_ADVANCE,
  WRK_RPT_EARNINGS,
  WRK_RPT_OVERTIME,
  WRK_RPT_PRODUCTION,
  WRK_RPT_UNPAID,
} from '@constants/internal-route.constant'

// The feature urls under each sidebar group. A group renders only when the user holds at least one
// of them (SidebarMenuItemWithSub `anyOf`), so a role granted nothing in a group never sees an
// empty accordion. Workers have no login; the one group a self-service EMPLOYEE uses is
// Approvals, where employees approve worker documents (Pending Approvals).

export const WORKERS_ROUTES = [WORKER, WORKER_PAYROLL]

export const LEAVE_ATTN_ROUTES = [
  WRK_LEAVE_TYPE,
  WRK_LEAVE_FOR_WORKER,
  WRK_ATTENDANCE_FOR_WORKER,
  WRK_WORKER_ATTENDANCE,
  WRK_WORKER_LEAVE,
]

// Piece workers' daily output, and the wage sheets that pay every worker (docs/labor-wages-plan.md).
export const WAGES_ROUTES = [WRK_DAILY_OUTPUT, WRK_WAGE_SHEET, WRK_ADVANCE]

// The wage reports: read-only views over the sheets, the output and the attendance.
export const REPORT_ROUTES = [WRK_RPT_EARNINGS, WRK_RPT_OVERTIME, WRK_RPT_PRODUCTION, WRK_RPT_UNPAID]

// What HR filed under Leave & Attn (My Requests), and where employees approve it (Pending Approvals).
export const APPROVAL_ROUTES = [LW_MY_REQUESTS, LW_PENDING_APPROVALS]

export const SETUP_ROUTES = [
  WRK_APPROVAL_WORKFLOW,
  WRK_CATEGORY,
  WRK_DESIGNATION,
  WRK_GRADE,
  WRK_CODE_CONFIG,
  WRK_WORK_TYPE,
  WRK_LABOR_TYPE,
  WRK_MAJOR_PRODUCT,
  WRK_MACHINE,
  WRK_PIECE_RATE,
  WRK_WAGE_SETTINGS,
]

/** Every screen in the console, in sidebar group order — the landing page's fallback list. */
export const ALL_ROUTES = [
  ...WORKERS_ROUTES,
  ...LEAVE_ATTN_ROUTES,
  ...WAGES_ROUTES,
  ...REPORT_ROUTES,
  ...APPROVAL_ROUTES,
  ...SETUP_ROUTES,
]
